import React from "react"

import * as reelReviewsStyles from "../../styles/beyond_spreadsheet/ReelReviews.module.css"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

const COUNT_PER_PAGE = 3

export default function ReelReviews(props) {
  const { content } = props

  const [limit, setLimit] = React.useState(COUNT_PER_PAGE)

  const cards = ChildSelector.select(
    content,
    `review-card`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(card => ({
    holder: card,
    content: ChildSelector.select(
      card,
      `content`,
      ChildSelector.SELECTOR_TYPE.ARRAY,
    ).map(c => c.innerHTML),
    author: ChildSelector.select(
      card,
      `author`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
  }))

  return (
    <>
      <div className={`row ${props.className} ${reelReviewsStyles.wrapper}`}>
        {cards &&
          cards.map((c, idx) => (
            <div key={idx} className={`col ${reelReviewsStyles.content}`}>
              <div className={`row ${reelReviewsStyles.cardWrapper}`} key={idx}>
                <div
                  className={`col-sm-12 col-md-12 col-lg-6 ${reelReviewsStyles.media}`}
                >
                  <WPImage
                    holder={c.holder}
                    selector={`stars`}
                    mode={DISPLAY_MODE.inline}
                    className={`${reelReviewsStyles.avatar}`}
                  />
                </div>
                <div className={`row ${reelReviewsStyles.testimonial}`}>
                  <p className={`${reelReviewsStyles}`}>
                    {c.content &&
                      c.content.map((t, indx) => (
                        <span
                          key={indx}
                          dangerouslySetInnerHTML={{ __html: t }}
                        />
                      ))}
                  </p>
                  <h4 className={`${reelReviewsStyles.authorName}`}>
                    {c.author}
                  </h4>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  )
}
